import { PulseStorage } from '@pulse/common';
import { QueryParamsService } from './query-params.service';

export class IsTestService extends QueryParamsService {
    constructor(
        protected override readonly pulseStorage: PulseStorage,
        public override readonly STORAGE_KEY = 'is-test',
    ) {
        super(pulseStorage, STORAGE_KEY);
    }
}
